import { render, staticRenderFns } from "./QnAList.vue?vue&type=template&id=58808058&"
import script from "./QnAList.vue?vue&type=script&lang=js&"
export * from "./QnAList.vue?vue&type=script&lang=js&"
import style0 from "./QnAList.vue?vue&type=style&index=0&id=58808058&prod&lang=scss&"
import style1 from "./QnAList.vue?vue&type=style&index=1&id=58808058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports